import { render, staticRenderFns } from "./SendDocument.vue?vue&type=template&id=3684d180&"
import script from "./SendDocument.vue?vue&type=script&lang=js&"
export * from "./SendDocument.vue?vue&type=script&lang=js&"
import style0 from "./SendDocument.vue?vue&type=style&index=0&id=3684d180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports